const rows = document.querySelectorAll('.alternating-content-row');
rows.forEach(row => {
    if (row.dataset.animationEnabled) {
        const rawMargin = parseInt(row.dataset.rootMargin) || -100;
        const rootMargin = Math.max(rawMargin, -100);
        const content = row.querySelector('.alternating-content-row__content');
        const image = row.querySelector('.alternating-content-row__image');
        const elements = [content, image].filter(Boolean);
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    elements.forEach(el => {
                        el.classList.add('animate__animated', 'animate__fadeIn');
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: `${rootMargin}px`, threshold: 0.1 });
        observer.observe(row);
    }
});